import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/XMP/XMP Classes/XMPDateTime.md";
import * as React from 'react';
export default {
  Content,
  React
};